import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'inside-out/components/shared/link';
import ArrowIcon from 'inside-out/images/white-arrow-icon.svg';
import {
	wrapperStyle,
	wrapperLinkStyle,
	titleStyle,
	bodyStyle,
	animate,
	arrowIconStyle,
	compressedStyle,
	minimizedStyle,
	compressedOneColumnStyle,
} from './styles';

class ColouredCardComponent extends React.PureComponent {
	static variants = {
		compressed: compressedStyle,
		compressedOneColumn: compressedOneColumnStyle,
		minimized: minimizedStyle,
	};

	static getWrapper = ({ background, animateVowel = true, minHeight }) => {
		return wrapperStyle(background, animateVowel, minHeight);
	};

	highlightTitle = (title) => {
		if (typeof title !== 'string') return title;

		const chars = title.toLowerCase().split('');
		let vowelIndex = chars.indexOf('o');
		if (vowelIndex < 0) {
			vowelIndex = chars.findIndex(c => 'aeu'.includes(c));
		}
		if (vowelIndex < 0) return title;

		let charIndex = -1;
		return title.split(' ').map((word, w) => {
			charIndex++;
			return (
				<span key={ `word-${ w }` }>
					{ word.split('').map((char, c) => (
						<span key={ `word-${ w }-${ c }` } className={ vowelIndex === charIndex++ ? animate : null }>
							{ char }
						</span>
					)) }
				</span>
			);
		});
	}

	render() {
		const {
			to,
			href,
			onClick,
			title,
			body,
			animateVowel = true,
			background,
			minHeight,
			arrow,
			variantWrapperStyle,
		} = this.props;

		return (
			<Link
				className={ wrapperLinkStyle }
				to={ to || '#' }
				href={ href }
				onClick={ onClick || null }
				data-component="Card">
				<article className={ variantWrapperStyle || wrapperStyle(background, animateVowel, minHeight) }>
					<h1 className={ titleStyle }>{ animateVowel ? this.highlightTitle(title) : title }</h1>
					{ body && <div className={ bodyStyle } dangerouslySetInnerHTML={{ __html: body }} /> }
					{ arrow && <img src={ ArrowIcon } alt="" className={ arrowIconStyle } /> }
				</article>
			</Link>
		);
	}
}

ColouredCardComponent.defaultProps = {
	minHeight: 286,
};

ColouredCardComponent.propTypes = {
	to: PropTypes.string,
	href: PropTypes.string,
	title: PropTypes.string,
	minHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	body: PropTypes.string,
	animateVowel: PropTypes.bool,
	background: PropTypes.string,
	arrow: PropTypes.bool,
	onClick: PropTypes.func,
	variantWrapperStyle: PropTypes.any,
};

export const ColouredCard = ColouredCardComponent;



// WEBPACK FOOTER //
// ./src/components/shared/cards/colouredCard/component.js